import { getParametrizedUrl } from '@x_x_x/utils';

import { URLS_API } from '@constants';

import { BaseApi, IRequestOptions } from '../BaseApi';

import {
	IApiTargetsFetchListRequestParams,
	IApiTargetsFetchListResponseData,

	IApiTargetsFetchItemRequestParams,
	IApiTargetsFetchItemResponseData,

	IApiTargetsFetchCurrentRequestParams,
	IApiTargetsFetchCurrentResponseData,
} from './types';

export class TargetsApi extends BaseApi {

	async fetchList() {
		return this.get<IApiTargetsFetchListRequestParams, IApiTargetsFetchListResponseData>({
			url: getParametrizedUrl(URLS_API.TARGETS),
		});
	}

	async fetchItem(options: IRequestOptions<IApiTargetsFetchItemRequestParams>) {
		const { params: { targetId } } = options;

		return this.get<IApiTargetsFetchItemRequestParams, IApiTargetsFetchItemResponseData>({
			url: getParametrizedUrl(URLS_API.TARGETS_ITEM, { targetId }),
		});
	}

	async fetchCurrent() {
		return this.get<IApiTargetsFetchCurrentRequestParams, IApiTargetsFetchCurrentResponseData>({
			url: getParametrizedUrl(URLS_API.TARGETS_CURRENT),
		});
	}

}
